import React from "react";
import { connect } from "react-redux";
import oneLogoLight from "../../assets/logos/one-logotype-light.svg";
import store from "../../helpers/store/Store";
import { reSet } from "../../helpers/actions/Action";
import { requestData } from "../../helpers/axios/Get";
import {
  LOGOUT_URL,
  FETCH_LOGOUT_SUCCESS,
  FETCH_LOGOUT_PENDING,
  FETCH_LOGOUT_ERROR,
} from "../../helpers/constants/Constants";
import { NavLink, Link } from "react-router-dom";

class Navbar extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  logOff = () => {
    this.props.onrequestLogOutReducer({ withCredentials: true });
    store.dispatch(reSet(true));
    window.location.href =
      "https://accounts.autodesk.com/Authentication/LogOut";
  };

  render() {
    return (
      <nav className="navbar navbar-viewer navbar-expand-lg">
        <header>
          <h1 className="m-0">
            <Link to="./" className="logotype" role="banner">
              <img src={oneLogoLight} alt="" />
              <span>Project Viewer</span>
            </Link>
          </h1>
          <div>
            <nav className="navbar-nav">
              <ul className="nav" style={{ verticalAlign: "middle" }}>
                <li
                  className={`nav-item ${
                    this.props.selected.text ? "" : "d-none"
                  }`}
                >
                  <a
                    className="nav-link"
                    href={`${this.props.selected.hrefbim360}/issues`}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <i className="icon icon-external-link"></i>
                    <span className="d-none d-lg-inline-block">
                      Project log
                    </span>
                  </a>
                </li>
                <li className="nav-item">
                  <NavLink
                    className="nav-link"
                    activeClassName="active"
                    to="/main"
                  >
                    <span className="d-lg-inline-block">Project Page</span>
                  </NavLink>
                </li>
                <li className="nav-item">
                  <NavLink
                    className="nav-link"
                    activeClassName="active"
                    to="/engineering"
                  >
                    <span className="d-lg-inline-block">Engineering Page</span>
                  </NavLink>
                </li>
                <li className="nav-item">
                  <NavLink
                    className="nav-link"
                    activeClassName="active"
                    to="/supplier"
                    style={{ borderTop: "1" }}
                  >
                    <span className="d-lg-inline-block">Supplier Zone</span>
                  </NavLink>
                </li>
                <li className="nav-item">
                  <NavLink
                    className="nav-link"
                    activeClassName="active"
                    to="/feedback"
                    style={{ borderTop: "1" }}
                  >
                    <span className="d-lg-inline-block">Feedback</span>
                  </NavLink>
                </li>
                <li className="nav-item">
                  <NavLink
                    className="nav-link"
                    activeClassName="active"
                    to="/training"
                    style={{ borderTop: "1" }}
                  >
                    <span className="d-lg-inline-block">Training</span>
                  </NavLink>
                </li>
                {/* <li className="nav-item">
                  <NavLink
                    className="nav-link"
                    activeClassName="active"
                    to="/personalHub"
                    style={{ borderTop: "1" }}
                  >
                    <span className="d-lg-inline-block">Personal Hub</span>
                  </NavLink>
                </li> */}
                <li className="nav-item dropdown">
                  <button
                    type="button"
                    className="btn nav-link nav-link-user dropdown-toggle"
                    id="navbarUser"
                    data-toggle="dropdown"
                    aria-haspopup="true"
                    aria-expanded="false"
                    style={{
                      borderBottom: "4",
                      borderTop: "0",
                      borderLeft: "0",
                      borderRight: "0",
                    }}
                  >
                    <span className="d-lg-inline-block">
                      {this.props.data ? this.props.data.name : "User Test"}
                    </span>
                    <img src={this.props.data.picture} alt="" />
                  </button>
                  <div
                    className="dropdown-menu dropdown-menu-right"
                    aria-labelledby="navbarUser"
                  >
                    <button
                      type="button"
                      className="dropdown-item"
                      onClick={(e) => this.logOff()}
                    >
                      Sign out
                    </button>
                  </div>
                </li>
              </ul>
            </nav>
          </div>
        </header>
      </nav>
    );
  }
}

const mapStateToProps = (state) => ({
  data: state.requestUserDataReducer.data,
  selected: state.getSelectedProjectReducer.data,
});

const mapDispatchToProps = (dispatch) => {
  return {
    onrequestLogOutReducer: (config) =>
      dispatch(
        requestData(
          LOGOUT_URL,
          {
            pending: FETCH_LOGOUT_PENDING,
            error: FETCH_LOGOUT_ERROR,
            success: FETCH_LOGOUT_SUCCESS,
          },
          config
        )
      ),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Navbar);
